<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
			<!--:hide-no-data="false"-->

					<v-select :id="id"
															hide-details
															:label="label"
															:class="classe"
															autocomplete="off"
															density="compact"
															:loading="loading"
															variant="outlined"
															:readonly="readonly"
															:disabled="disabled"
															v-model="selectedAux"
															clear-icon="mdi-close"
															:items="filteredItems"
															:clearable="clearable"
															:item-title="itemTitle"
															:item-value="itemValue"
															:return-object="returnObject"
															:counter="false"
															:menu-props="{closeOnContentClick: false,  maxHeight: '300px', contentClass: 'my-list-class' }">
								<template v-slot:prepend-item>
											<div style="padding: 0px 10px;">
														<v-text-field data-lpignore="true" class="inp" density="compact" v-model="search" label="Pesquisar" hide-details
																												clearable prepend-inner-icon="mdi-magnify" placeholder="Pesquisar" single-line></v-text-field>
											</div>
								</template>
								<template v-slot:item="{ item, props: { onClick } }">
											<v-list-item class="small-list-item" :title="item.title" @click="onClick"/>
								</template>
					</v-select>

</template>

<script>
   import _ from 'lodash'

   export default {
      props: {
         lista: { type: Array, default: () => [] },
         label: {default: 'Label'},
         id: {default: 'select'},
         itemTitle: {default: 'title'},
         classe: {default: ''},
         model: {default: null},
         itemValue: {default: null},
         loading: {default: true},
         clearable: {default: true},
         returnObject: {default: true},
         disabled: {default: false},
         readonly: {default: false},
      },
      data() {
         return {
            search: '',
            listaAux: [],
         }
      },
      methods: {
         validarCampo(campo) {
            if (campo !== undefined && campo !== null && campo !== '') {
               return true
            } else {
               return false
            }
         },
      },
      mounted() {
         // todo Adiconar esse coddigo no vue.config.js para não dar erro de "ResizeObserver loop"
         // devServer: {
         //    client: {
         //       overlay: {
         //          runtimeErrors: error => {
         //             const ignoreErrors = [
         //                'ResizeObserver loop completed with undelivered notifications.'
         //             ]
         //             return !ignoreErrors.includes(error.message)
         //          }
         //       }
         //    }
         // }
      },
      computed: {
         filteredItems() {
            const termo = this.search?.toLowerCase()?.trim();
            if (this.validarCampo(termo)) {
               return _.filter(this.lista, item => {
                  const val = typeof item === 'object' ? item[this.itemTitle] : item;
                  return val?.toString()?.toLowerCase().includes(termo);
               });
            }
            return this.lista;
         },
         selectedAux: {
            get() {
               return this.model
            },
            set(v) {
               this.$emit('update', v)
               return this.selectedAux
            }
         },
      },
      watch: {
         // search: function () {
         //    console.log(this.search);
         //    console.log(this.lista.length);
         //    let exp = new RegExp(this.search.trim(), 'i');
         //    if (this.validarCampo(this.itemTitle)) {
         //       this.listaAux = _.slice(_.filter(this.lista, p => exp.test(p[this.itemTitle])), 0,  this.lista.length)
         //    } else {
         //       this.listaAux = _.slice(_.filter(this.lista, p => exp.test(p)), 0, this.lista.length)
         //    }
         // },
      },
   }
</script>

<style scoped>
			.my-list-class .v-list-item {
						max-height: none;
			}
</style>
